export const ACCOUNT_UPDATE = "ACCOUNT_UPDATE";
export const CONTRACT_LOADED = "CONTRACT_LOADED";
export const DATA_LOADED = "DATA_LOADED";
export const THEME_TOGGLER= "THEME_TOGGLER";

export const RATE ="RATE";
